import { VTooltip, VSnackbar } from "vuetify/lib";

export default function vuetifyOverrides() {
  VTooltip.extendOptions.props.openDelay.default = () => 500;
  VSnackbar.extendOptions.props.contentClass.default = () => "tw-text-center";
}
